import styled from "styled-components"
import {CSVLink} from "react-csv"

import {Hr} from "@irati/ui/src/Layout"
import Button from "@irati/ui/src/Button"
import Label from "../../../../Menu/Label"

export const MarginBottom = styled.div`
  margin-bottom: 20px;
`

export const StyledLabel = styled(Label)`
  margin: 0;
  width: 100%;
  display: inline-block;
  text-align: center;
`

export const CodeSelectionMenu = styled.div`
  max-width: 350px;
  margin-bottom: 20px;
`

export const ImportCodes = styled(Button)`
  margin-top: 20px;
`

export const Flex = styled.div`
  display: flex;
  > * {
    flex: 1 1 0;
  }
`

export const StyledHR = styled(Hr)`
  margin: 0;
`

export const StyledCSVLink = styled(CSVLink)`
  text-decoration: underline;
  margin-bottom: 15px;
  display: block;
`
